import { ForwardRefExoticComponent, RefAttributes } from "react"
import { LucideProps } from "lucide-react"

export const FindingTypes = {
  NAMING_AND_TYPOS: "naming_and_typos",
  CODE_HYGIENE: "code_hygiene",
  TEST_QUALITY: "test_quality",
  TYPE_INCONSISTENCY: "type_inconsistency",
  CONCISENESS: "conciseness",
  BREAKING_CHANGE: "breaking_change",
  LOG_ERROR: "log_error",
  CODE_DEDUP_AND_CONVENTIONS: "code_dedup_and_conventions",
  ADDRESSED: "addressed",
  SECURITY_PATTERNS: "security_patterns",
  REST_API_BEST_PRACTICES: "rest_api_best_practices"
} as const

export type FindingType = (typeof FindingTypes)[keyof typeof FindingTypes]

export interface FindingConfig {
  findingType: FindingType
  enabled: boolean
}

export interface RepoPaths {
  repoId: string
  repoName: string
  paths: string[]
}

export interface ReviewerConfig {
  findingConfig: FindingConfig[]
  excludedConfig: RepoPaths[]
}

export interface AcceptanceRates {
  acceptanceRates: Record<FindingType, AcceptanceStats>
}

export interface AcceptanceStats {
  globalRate: number
  orgRate: number
  addressedOrgCounter: number
  orgCounter: number
}

export type ReviewerType = {
  display: string
  icon: ForwardRefExoticComponent<Omit<LucideProps, "ref"> & RefAttributes<SVGSVGElement>>
  description: string
  isConfigurable: boolean
  findingType: FindingType
}
